module.exports = __webpack_public_path__ + "media/fonts/calibri/Calibri-Bold-Italic-1a0c5e92f3ba50b2b2114d2d8a2aeac9.ttf";